(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  /*
   * Power Unit upsell (snippets/hr-p.upsell-cart-page.liquid): adds the Power Unit with AJAX and re-renders the cart
   * drawer, the same way the theme product form does (it fires "variant:add" and "cart:change" with the drawer section
   * HTML). The drawer replaces its HTML on every cart change, so the click is delegated from the document. On the cart
   * page the plain /cart/add link is kept.
   *
   * This code lives here and not in the snippet: Shopify only loads the "javascript" tag code of the files rendered
   * with the page, and the upsell is often rendered later (when the drawer HTML is re-rendered after an add to cart).
   * This section is rendered on every page.
   *
   * The drawer can replace its HTML while the request runs (it does it 1.25s after a quantity change), so the button
   * may no longer be in the page when the response comes back: nothing below relies on it after the request. Only a
   * request that could not be sent at all falls back to the /cart/add link (it would add the product twice otherwise).
   */
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('.add-power-unit-container #apu-atc-btn');
    const settings = window.themeVariables?.settings;

    if (!button || !settings || settings.pageType === 'cart' || settings.cartType === 'page') {
      return;
    }

    event.preventDefault();

    if (button.getAttribute('aria-busy') === 'true') {
      return;
    }

    button.setAttribute('aria-busy', 'true');

    const upsellElement = button.closest('.add-power-unit');
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sectionsToBundle } }));

    let response;

    try {
      response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [{ id: new URL(button.href).searchParams.get('id'), quantity: 1 }],
          sections: sectionsToBundle
        })
      });
    } catch (error) {
      window.location.href = button.href; // Network error: fall back to the plain /cart/add link
      return;
    }

    try {
      const responseJson = await response.json().catch(() => ({}));

      upsellElement?.querySelector('[role="alert"]')?.remove();

      if (!response.ok) {
        const errorElement = document.createElement('p');
        errorElement.className = 'text-error text-xs';
        errorElement.setAttribute('role', 'alert');
        errorElement.textContent = responseJson['description'] || responseJson['message'] || 'The Power Unit could not be added, please try again.';
        upsellElement?.append(errorElement);
        return;
      }

      const cartContent = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
      cartContent['sections'] = responseJson['sections'];

      document.documentElement.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: responseJson['items'] || [responseJson], cart: cartContent } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cartContent } }));
    } catch (error) {
      // The Power Unit is in the cart but the drawer could not be updated from the response: reload it from the server
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    } finally {
      button.removeAttribute('aria-busy');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-section-hero-media"] && !Shopify.designMode) return;
  try {
    
  /*
   * ES Section Hero Media: plays the background video only while the section is on screen. A YouTube video is created
   * with the YouTube IFrame API (muted, looped, without controls) and is only shown once it really plays, so the
   * YouTube loading screen is never visible. Visitors who ask for reduced motion keep the still image.
   */
  if (!window.customElements.get('es-hero-media')) {
    const YOUTUBE_API_URL = 'https://www.youtube.com/iframe_api';
    const HELPLY_CHAT_HASH = '#helply-agent-root-container';

    // The Helply AI chat (third party script of the "Groove Widget" custom HTML in the footer) exposes
    // window.helplyAgentWidget once loaded. Its script is async, so a click right after the page load waits for it (5s).
    const openHelplyChat = (attempt = 0) => {
      if (window.helplyAgentWidget?.open) {
        window.helplyAgentWidget.open();
      } else if (attempt < 50) {
        setTimeout(() => openHelplyChat(attempt + 1), 100);
      }
    };

    /*
     * Buttons whose link starts with "#" scroll smoothly to the element with that ID (the theme "scroll-padding" on the
     * html element keeps it below the sticky header), and move the focus there for keyboard and screen reader users.
     * "#helply-agent-root-container" opens the Helply chat instead. Listened in the capture phase so it runs before the
     * theme anchor scroll, which then sees the prevented event.
     */
    document.addEventListener('click', (event) => {
      const link = event.target.closest('.es-hero-media__button[href^="#"]');

      if (link?.hash === HELPLY_CHAT_HASH) {
        event.preventDefault();
        openHelplyChat();
        return;
      }

      const target = link && link.hash.length > 1 ? document.getElementById(decodeURIComponent(link.hash.slice(1))) : null;

      if (!target) {
        return;
      }

      event.preventDefault();
      target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      history.replaceState(null, '', link.hash);

      if (!target.hasAttribute('tabindex')) {
        target.setAttribute('tabindex', '-1');
      }

      target.focus({ preventScroll: true });
    }, { capture: true });

    // Polling instead of window.onYouTubeIframeAPIReady, because the theme already uses that callback for its own videos
    const loadYouTubeApi = () => new Promise((resolve) => {
      if (!window.YT && !document.querySelector(`script[src="${YOUTUBE_API_URL}"]`)) {
        const script = document.createElement('script');
        script.src = YOUTUBE_API_URL;
        document.head.append(script);
      }

      const interval = setInterval(() => {
        if (window.YT && window.YT.loaded) {
          clearInterval(interval);
          resolve();
        }
      }, 100);
    });

    class EsHeroMedia extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.youtubeId = this.getAttribute('youtube-id');

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video?.pause();
          return;
        }

        // The video can already play (autoplay) before this script runs, so the current state is checked too
        if (this.video) {
          this.video.addEventListener('playing', () => this.setAttribute('playing', ''), { once: true });

          if (!this.video.paused && this.video.readyState > 2) {
            this.setAttribute('playing', '');
          }
        }

        this.observer = new IntersectionObserver(([entry]) => entry.isIntersecting ? this.play() : this.pause());
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.player?.destroy();
        this.player = null;
        this.playerPromise = null;
      }

      async play() {
        if (this.video) {
          this.video.play().catch(() => {}); // Autoplay can be refused (low power mode...), the image stays visible
        } else if (this.youtubeId) {
          (await this.getYouTubePlayer()).playVideo();
        }
      }

      pause() {
        if (this.video) {
          this.video.pause();
        } else {
          this.player?.pauseVideo();
        }
      }

      getYouTubePlayer() {
        this.playerPromise = this.playerPromise || loadYouTubeApi().then(() => new Promise((resolve) => {
          this.player = new window.YT.Player(this.querySelector('[data-youtube-player]'), {
            host: 'https://www.youtube-nocookie.com',
            videoId: this.youtubeId,
            playerVars: {
              autoplay: 1,
              mute: 1,
              loop: 1,
              playlist: this.youtubeId,
              controls: 0,
              disablekb: 1,
              fs: 0,
              iv_load_policy: 3,
              modestbranding: 1,
              playsinline: 1,
              rel: 0,
              origin: window.location.origin
            },
            events: {
              onReady: (event) => {
                event.target.mute();
                event.target.getIframe().setAttribute('tabindex', '-1');
                resolve(event.target);
              },
              onStateChange: (event) => {
                if (event.data === window.YT.PlayerState.PLAYING) {
                  this.setAttribute('playing', '');
                } else if (event.data === window.YT.PlayerState.ENDED) {
                  event.target.playVideo(); // In case the "loop" parameter is ignored
                }
              }
            }
          });
        }));

        return this.playerPromise;
      }
    }

    window.customElements.define('es-hero-media', EsHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["es-section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  /*
   * ES Section Product Tabs. <es-product-tabs> switches the tab panels (ARIA tabs: arrow keys, Home and End move between
   * tabs). <es-product-slider> keeps the progress bar and the previous / next buttons in sync with the native scroll.
   */
  if (!window.customElements.get('es-product-tabs')) {
    class EsProductTabs extends HTMLElement {
      connectedCallback() {
        this.tabList = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

        this.tabs.forEach((tab) => tab.addEventListener('click', () => this.select(tab)));
        this.tabList?.addEventListener('keydown', this.onKeyDown.bind(this));

        // Theme editor: show the tab of the block selected in the sidebar
        this.addEventListener('shopify:block:select', (event) => {
          const tab = event.target.closest('[role="tab"]');

          if (tab) {
            this.select(tab);
          }
        });
      }

      select(tab, focus = false) {
        this.tabs.forEach((item) => {
          const isSelected = item === tab;

          item.setAttribute('aria-selected', isSelected ? 'true' : 'false');
          item.tabIndex = isSelected ? 0 : -1;
          document.getElementById(item.getAttribute('aria-controls')).hidden = !isSelected;
        });

        if (focus) {
          tab.focus({ preventScroll: true });
        }

        this.scrollTabIntoView(tab);
      }

      // Keeps the selected tab visible when the tab list scrolls horizontally (mobile)
      scrollTabIntoView(tab) {
        const navigation = this.tabList.parentElement;
        const navigationRect = navigation.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();

        if (tabRect.left < navigationRect.left || tabRect.right > navigationRect.right) {
          navigation.scrollBy({ left: tabRect.left - navigationRect.left - (navigationRect.width - tabRect.width) / 2, behavior: 'smooth' });
        }
      }

      onKeyDown(event) {
        const index = this.tabs.indexOf(document.activeElement);
        let nextIndex;

        switch (event.key) {
          case 'ArrowRight':
            nextIndex = (index + 1) % this.tabs.length;
            break;
          case 'ArrowLeft':
            nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
            break;
          case 'Home':
            nextIndex = 0;
            break;
          case 'End':
            nextIndex = this.tabs.length - 1;
            break;
          default:
            return;
        }

        event.preventDefault();
        this.select(this.tabs[nextIndex], true);
      }
    }

    class EsProductSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.arrows = Array.from(this.querySelectorAll('[data-direction]'));
        this.update = this.update.bind(this);

        this.track.addEventListener('scroll', this.update, { passive: true });
        this.arrows.forEach((arrow) => arrow.addEventListener('click', () => {
          this.track.scrollBy({ left: Number(arrow.dataset.direction) * this.track.clientWidth, behavior: 'smooth' });
        }));

        // Also fires when a hidden tab panel is shown, as its size goes from 0 to the real one
        this.resizeObserver = new ResizeObserver(this.update);
        this.resizeObserver.observe(this.track);
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
      }

      update() {
        const { scrollLeft, scrollWidth, clientWidth } = this.track;

        if (scrollWidth === 0) {
          return;
        }

        const isScrollable = scrollWidth - clientWidth > 1;

        this.toggleAttribute('scrollable', isScrollable);
        this.style.setProperty('--es-product-tabs-progress-size', clientWidth / scrollWidth);
        this.style.setProperty('--es-product-tabs-progress-position', scrollLeft / scrollWidth);
        this.arrows[0].disabled = scrollLeft <= 1;
        this.arrows[1].disabled = scrollLeft + clientWidth >= scrollWidth - 1;
      }
    }

    window.customElements.define('es-product-tabs', EsProductTabs);
    window.customElements.define('es-product-slider', EsProductSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faqs-page"] && !Shopify.designMode) return;
  try {
    
class FaqPage extends HTMLElement {
  static singleOpen = false;

  connectedCallback() {
    this._items = Array.from(this.querySelectorAll('.faq-page__item'));
    this._tabsEl = this.querySelector('.faq-page__tabs');
    this._categoryLabel = this.querySelector('.faq-page__category-label');
    this._searchInput = this.querySelector('.faq-page__search-input');
    this._searchPopup = this.querySelector('.faq-page__search-popup');
    this._modal = this.querySelector('.faq-page__modal');
    this._modalTitle = this.querySelector('.faq-page__modal-title');
    this._modalAnswer = this.querySelector('.faq-page__modal-answer');

    this._buildTabs();
    this._bindSearch();
    this._bindModal();
    this._bindAccordion();
    this._bindCopyLinks();
    this._openFromUrl();
  }

  _buildTabs() {
    const seen = new Set();
    this._items.forEach((item) => { if (item.dataset.category) seen.add(item.dataset.category); });

    let orderList = [];
    try { orderList = JSON.parse(this.dataset.categoryOrder || '[]'); } catch (e) {}
    if (!Array.isArray(orderList) || !orderList.length) orderList = [...seen];

    const categories = orderList.filter((c) => seen.has(c));

    // Create the "All" tab first and set it as active
    const allBtn = document.createElement('button');
    allBtn.className = 'faq-page__tab';
    allBtn.setAttribute('role', 'tab');
    allBtn.setAttribute('aria-selected', 'true');
    allBtn.dataset.cat = 'all';
    allBtn.textContent = 'View All';
    allBtn.addEventListener('click', () => this._selectTab('all', allBtn));
    this._tabsEl.appendChild(allBtn);

    // Create specific category tabs
    categories.forEach((cat) => {
      const btn = document.createElement('button');
      btn.className = 'faq-page__tab';
      btn.setAttribute('role', 'tab');
      btn.setAttribute('aria-selected', 'false');
      btn.dataset.cat = cat;
      btn.textContent = cat;
      btn.addEventListener('click', () => this._selectTab(cat, btn));
      this._tabsEl.appendChild(btn);
    });

    this._filterItems('all');
  }

  _selectTab(cat, btn) {
    this._tabsEl.querySelectorAll('.faq-page__tab').forEach((b) => {
      b.setAttribute('aria-selected', 'false');
    });
    btn.setAttribute('aria-selected', 'true');
    this._filterItems(cat);
  }

  _filterItems(cat) {
    this._categoryLabel.textContent = cat === 'all' ? 'All FAQs' : cat;

    // Filter group elements and toggle group titles appropriately
    const groups = Array.from(this.querySelectorAll('.faq-page__group'));
    groups.forEach((group) => {
      const visible = (cat === 'all' || group.dataset.category === cat);
      group.hidden = !visible;
      const titleEl = group.querySelector('.faq-page__group-title');
      if (titleEl) {
        titleEl.hidden = (cat !== 'all');
      }
    });

    this._items.forEach((item) => {
      const visible = (cat === 'all' || item.dataset.category === cat);
      item.hidden = !visible;
      if (!visible) {
        const d = item.querySelector('.faq-page__details');
        if (d) { d.classList.remove('active'); d.querySelector('.faq-page__question').setAttribute('aria-expanded', 'false'); }
      }
    });
  }

  _bindSearch() {
    this._searchInput.addEventListener('input', () => this._onSearch());
    this._searchInput.addEventListener('focus', () => {
      if (this._searchInput.value.trim()) this._onSearch();
    });
    this._searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') this._closePopup();
    });
    document.addEventListener('click', (e) => {
      if (!this.querySelector('.faq-page__search-wrap').contains(e.target)) {
        this._closePopup();
      }
    });
  }

  _onSearch() {
    const q = this._searchInput.value.trim().toLowerCase();
    if (!q) { this._closePopup(); return; }

    const matches = this._items.filter((item) =>
      item.dataset.title.toLowerCase().includes(q)
    );

    this._searchPopup.innerHTML = '';

    if (matches.length === 0) {
      const msg = document.createElement('div');
      msg.className = 'faq-page__search-no-results';
      msg.textContent = 'No results found';
      this._searchPopup.appendChild(msg);
    } else {
      matches.forEach((item) => {
        const btn = document.createElement('button');
        btn.className = 'faq-page__search-result';
        btn.setAttribute('role', 'option');
        btn.textContent = item.dataset.title;
        btn.addEventListener('click', () => {
          this._closePopup();
          this._openModal(
            item.dataset.title,
            item.querySelector('.faq-page__answer-inner').innerHTML
          );
        });
        this._searchPopup.appendChild(btn);
      });
    }

    this._searchPopup.hidden = false;
  }

  _closePopup() {
    this._searchPopup.hidden = true;
    this._searchPopup.innerHTML = '';
  }

  _bindModal() {
    this.querySelector('.faq-page__modal-close').addEventListener('click', () => this._closeModal());
    this.querySelector('.faq-page__modal-backdrop').addEventListener('click', () => this._closeModal());
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && !this._modal.hidden) this._closeModal();
    });
  }

  _openModal(title, answerHtml) {
    this._modalTitle.textContent = title;
    this._modalAnswer.innerHTML = answerHtml;
    this._modal.hidden = false;
    document.body.style.overflow = 'hidden';
    this.querySelector('.faq-page__modal-close').focus();
  }

  _closeModal() {
    this._modal.hidden = true;
    document.body.style.overflow = '';
  }

  _openFromUrl() {
    const handle = new URLSearchParams(window.location.search).get('entry');
    if (!handle) return;
    const btn = this.querySelector(`.faq-page__copy-btn[data-url="/pages/faqs?entry=${handle}"]`);
    if (!btn) return;
    const item = btn.closest('.faq-page__item');
    const details = item.querySelector('.faq-page__details');
    const question = details.querySelector('.faq-page__question');
    details.classList.add('active');
    question.setAttribute('aria-expanded', 'true');
    setTimeout(() => item.scrollIntoView({ behavior: 'smooth', block: 'center' }), 100);
  }

  _bindCopyLinks() {
    this.querySelectorAll('.faq-page__copy-btn').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const url = window.location.origin + btn.dataset.url;
        navigator.clipboard.writeText(url).then(() => {
          btn.classList.add('copied');
          setTimeout(() => btn.classList.remove('copied'), 2000);
        });
      });
    });
  }

  _bindAccordion() {
    this._items.forEach((item) => {
      const details = item.querySelector('.faq-page__details');
      const btn = details.querySelector('.faq-page__question');
      btn.addEventListener('click', () => {
        const isOpen = details.classList.contains('active');
        if (FaqPage.singleOpen) {
          this._items.forEach((other) => {
            const d = other.querySelector('.faq-page__details');
            d.classList.remove('active');
            d.querySelector('.faq-page__question').setAttribute('aria-expanded', 'false');
          });
        }
        if (!isOpen) {
          details.classList.add('active');
          btn.setAttribute('aria-expanded', 'true');
        } else if (!FaqPage.singleOpen) {
          details.classList.remove('active');
          btn.setAttribute('aria-expanded', 'false');
        }
      });
    });
  }
}

customElements.define('faq-page', FaqPage);

  } catch(e) { console.error(e); }
})();
})();
